/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(function () {
  
  var sr = ScrollReveal();

  if (typeof ScrollReveal !== 'undefined' && $(window).width() > 799) {
    sr.reveal('.pd_image-carousel-container', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true
    });
  }

  var POPUP_MAX_WIDTH = 799;
  var popupSwipers = {};

  function openPopup(sectionId, index) {
    if ($(window).width() > POPUP_MAX_WIDTH) return;
    var $popup = $('#pd-carousel-popup-' + sectionId);
    if (!$popup.length) return;

    $popup.addClass('is-open').attr('aria-hidden', 'false');
    $('html').addClass('pd-carousel-popup-open');

    if (!popupSwipers[sectionId]) {
      popupSwipers[sectionId] = new Swiper($popup.find('.pd-carousel-popup__swiper')[0], {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        grabCursor: true,
        observer: true,
        observeParents: true,
        zoom: { maxRatio: 4, minRatio: 1, toggle: true },
        navigation: {
          prevEl: '.pd-carousel-popup-prev-' + sectionId,
          nextEl: '.pd-carousel-popup-next-' + sectionId,
        },
        pagination: {
          el: '.pd-carousel-popup-pagination-' + sectionId,
          clickable: true,
        },
        on: {
          // Leaving a slide zoomed in makes the next one open panned/oversized.
          slideChange: function () {
            if (this.zoom) this.zoom.out();
          },
        },
      });
    }
    var sw = popupSwipers[sectionId];
    sw.update();
    if (sw.zoom) sw.zoom.out();
    sw.slideTo(index, 0);
  }

  function closePopup(sectionId) {
    var sw = popupSwipers[sectionId];
    if (sw && sw.zoom) sw.zoom.out();
    $('#pd-carousel-popup-' + sectionId).removeClass('is-open').attr('aria-hidden', 'true');
    $('html').removeClass('pd-carousel-popup-open');
  }

  function initPopup(sectionId, $swiperEl) {
    var $popup = $('#pd-carousel-popup-' + sectionId);
    if (!$popup.length) return;

    // Open on slide tap (mobile only). Swiper's preventClicks suppresses this after a drag.
    $swiperEl.find('.swiper-wrapper > .swiper-slide').on('click', function () {
      openPopup(sectionId, $(this).index());
    });

    $popup.find('.pd-carousel-popup__close').on('click', function () {
      closePopup(sectionId);
    });
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' && $popup.hasClass('is-open')) closePopup(sectionId);
    });
  }

  function initImageCarousel(sectionId) {
    var $swiperEl = $('#pd-image-carousel-' + sectionId);
    if (!$swiperEl.length) return;

    var swiper = new Swiper($swiperEl[0], {
      slidesPerView: 'auto',
      spaceBetween: 16,
       grabCursor: true,
    speed: 300,
    resistanceRatio: 0.85,
    touchRatio: 1,
    touchAngle: 45,
    threshold: 3,
    followFinger: true,
    simulateTouch: true,
    // true (Swiper default) makes Swiper preventDefault the pointerdown, which suppresses the
    // browser's native image drag — otherwise dragging an <img> hijacks the mouse swipe.
    touchStartPreventDefault: true,
    touchMoveStopPropagation: false,
    nested: true,
    edgeSwipeDetection: true,
    edgeSwipeThreshold: 20,
    watchSlidesProgress: true,
    freeMode: {
      enabled: true,
      momentum: true,
      momentumRatio: 0.4,
      momentumVelocityRatio: 1,
      momentumBounce: false,
      // Snap to the nearest slide after the drag/momentum instead of stopping mid-slide.
      sticky: true,
      minimumVelocity: 0.02,
    },
    cssMode: false,
    keyboard: { enabled: true, onlyInViewport: true },
    mousewheel: { forceToAxis: true, sensitivity: 0.5, releaseOnEdges: true },
      navigation: {
        prevEl: '.pd-carousel-prev-' + sectionId,
        nextEl: '.pd-carousel-next-' + sectionId,
      },
      pagination: {
        el: '.pd-carousel-pagination-' + sectionId,
        clickable: true,
      },
      breakpoints: {
        1279: { spaceBetween: 24 }
      }
    });

    // Free mode for drag only: with a trackpad it jumps on every wheel event and snaps mid-gesture
    var parentEl = $swiperEl[0].parentNode;
    parentEl.addEventListener('wheel', function () {
      swiper.params.freeMode.enabled = false;
    }, { capture: true, passive: true });
    parentEl.addEventListener('pointerdown', function () {
      swiper.params.freeMode.enabled = true;
    }, { capture: true, passive: true });

    initPopup(sectionId, $swiperEl);
  }

  var instances = window.DeskImageCarousel || {};
  $.each(instances, function (id) {
    initImageCarousel(id);
  });
});
